export interface GetReminderByIdOptions {
  /**
   * @since 7.1.0
   */
  id: string;
}
